<template>
  <WebinarExplainDialog
    :class="{'opc-modal-dialog': isModal}"
    :show-close="!isModal"
    :visible="visible"
    @close="closeDialog">
    <template v-if="isModal" #back>
      <NavBack :backHandler="closeDialog" class="mb24" />
    </template>
  </WebinarExplainDialog>
</template>

<script>
import NavBack from '@/components/nav-back.vue';

export default {
  name: 'WebinarExplainDiffDialog',
  components: { NavBack },
  props: {
    visible: Boolean,
  },
  computed: {
    isModal() {
      return this.$context?.is.modal;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import "@/styles/modal.scss";

.opc-modal-dialog {
  &.webinar-explain-dialog {
    .webinar-explain-dialog_title {
      font-family: $happy-display;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%; /* 28.8px */
      padding: 24px 0px 4px 0px !important;
      margin-bottom: 0px !important;
    }

    .zm-dialog {
      .zm-dialog__header {
        padding: 0px;
      }
    }
  }
}
</style>
